import React from "react";
import "./How_It_Works_card.css";

function How_It_Works_card({ numberText, headingText, text }) {
  return (
    <>
      <section className="How_It_Works_card">
        <div className="content_holder">
          <div className="heading_holder">
            <h4>{numberText}</h4>
            <h2>{headingText}</h2>
          </div>

          <div className="text_holder">
            <div className="p_holder">
              <p>{text}</p>
            </div>
            <div className="overlay_holder"></div>
          </div>
        </div>
      </section>
    </>
  );
}

export default How_It_Works_card;
